import { Box, Button, CardContent, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { LinkType } from '../../constans';
import { getLinks } from '../../helpers';

export const Success: React.FC = () => {
  const { t } = useTranslation();
  const { language } = useParams();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '1rem' }}>
      <Card sx={{ backgroundColor: '#E5F8F8', boxShadow: 'none', borderRadius: '30px' }}>
        <CardContent>
          <Typography gutterBottom variant="h5" textAlign="center" component="div">
            {t('infoText.email.header')}
          </Typography>
          <ul>
            <li>{t('infoText.email.control1')}</li>
            <li style={{ marginTop: '0.5rem' }}>{t('infoText.email.control2')}</li>
          </ul>
        </CardContent>
      </Card>
      <Button
        component="a"
        href={getLinks(LinkType.sendAgain, language)}
        fullWidth
        sx={{ maxWidth: 308, margin: 'auto', color: 'white', textTransform: 'none', mt: '2rem' }}
        variant="contained"
        color="success"
      >
        {t('buttonLabels.sendAgain')}
      </Button>
    </Box>
  );
};
